import styled from "styled-components";

type ContentProps = {
  minHeight?: number;
};

export const Content = styled.div<ContentProps>`
  display: flex;
  position: relative;
  width: 100%;
  min-height: 500px;
  min-height: ${({ minHeight }) => minHeight}px;
`;

export const Absolute = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;
